
















import { Vue, Component, Prop } from 'vue-property-decorator';
import FieldSettingsContainer from '@/fields/context-menu/components/FieldSettingsContainer.vue';
import FieldMoveItem from '@/fields/context-menu/components/menu-components/FieldMoveItem.vue';
import { IDocumentPage } from '@/types/document-page';

@Component({
  components: {
    FieldSettingsContainer,
    FieldMoveItem,
  },
})
export default class FieldMove extends Vue {
  @Prop() pages: IDocumentPage[];
  @Prop() currentPageId: string;
  @Prop() height: string;
  @Prop() flipped: boolean;

  handleClick(payload: string) {
    this.$emit('move', payload);
  }
}
